import { render } from "./TermoUsoView.vue?vue&type=template&id=6bfe2adb"
import script from "./TermoUsoView.vue?vue&type=script&lang=js"
export * from "./TermoUsoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__